import React, { useEffect, useState } from "react";
import Style from "./WSAInstallationPage.module.css";
import { ReactComponent as AppStore } from "../../../assets/svg/app_store.svg";
import { ReactComponent as GooglePlay } from "../../../assets/svg/google_play.svg";
import { ReactComponent as WSALogo } from "../../../assets/svg/wsa_mobile_logo.svg";
import { ReactComponent as WSAVector1 } from "../../../assets/svg/wsa_vector1.svg";
import { ReactComponent as WSAVector2 } from "../../../assets/svg/wsa_vector2.svg";
import { ReactComponent as WSAVector3 } from "../../../assets/svg/wsa_vector3.svg";
import wsa_banner from "../../../assets/wsa_banner.png";
import wsa_homepage from "../../../assets/wsa_home_page.png";
import wsa_subscription from "../../../assets/wsa_subscription.png";
import { Image } from "semantic-ui-react";
import { useMobileOS } from "../../../hooks/useMobileOS";

const WSAInstallationPage = () => {
  const { getMobileOperatingSystem } = useMobileOS();
  const [isMobile, setIsMobile] = useState(false);
  const maxMobileWidth = 932; //768;
  const mobileOS = ["Android", "iOS"];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= maxMobileWidth);
    window.addEventListener("resize", handleResize);

    let operatingSystem = getMobileOperatingSystem();

    if (mobileOS.includes(operatingSystem)) {
      setIsMobile(true);
      openMobileStore(operatingSystem);
    }

    if (window.innerWidth <= maxMobileWidth) {
      setIsMobile(true);
    }

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openMobileStore = (mobileOperationSystem: string): void => {
    let appUrl = "";
    switch (mobileOperationSystem) {
      case "Android":
        appUrl = process.env.REACT_APP_MOBILE_APP_CHPLAY_URL || "";
        break;
      case "iOS":
        appUrl = process.env.REACT_APP_MOBILE_APP_APPSTORE_URL || "";
        break;
      default:
        break;
    }

    if (appUrl) window.location.href = appUrl;
  };

  if (isMobile) {
    return (
      <>
        <div className={Style.wsa_mobile_wrapper}>
          <div className={Style.wsa_mobile_container}>
            <div className={Style.wsa_banner}>
              <Image src={wsa_banner} />
            </div>
            <div className={Style.wsa_logo}>
              <WSALogo />
              </div>
            <div className={Style.information}>
              <p>Workshop Service Assist</p>
              <div className={Style.group_download}>
                <div className={Style.downloadButton}>
                  <AppStore onClick={() => openMobileStore("iOS")} />
                  <GooglePlay onClick={() => openMobileStore("Android")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
    <div className={Style.wsa_wrapper}>
        <div className={Style.wsa_container}>
          <div className={Style.wsa_vector}>
            <WSAVector1 />
          </div>
          <div className={Style.wsa_vector}>
            <WSAVector2 />
          </div>
          <div className={Style.wsa_vector}>
            <WSAVector3/>
          </div>
          <div className={Style.wsa_home_page}>
            <Image src={wsa_homepage} />
          </div>
          <div className={Style.wsa_subscription}>
            <Image src={wsa_subscription} />
          </div>
          <div className={Style.main_content}>
            <div className={Style.information}>
              <p className={Style.title}>Workshop Service Assist</p>
              <div className={Style.details}>
                <p>Schedule and plan Remote Diagnostic services</p>
                <p>Chat with Bosch expert during Remote sessions</p>
                <p>Access various Automotive services within on mobile application</p>
                <p>Get car repair support</p>
                <p>Live video transmission with Visual Connect Pro</p>
                <p>Automatic vehicle license plate and vin scan</p>
              </div>
              <div className={Style.group_download}>
                <p>Download now</p>
                <div className={Style.downloadButton}>
                  <AppStore onClick={() => openMobileStore("iOS")} />
                  <GooglePlay onClick={() => openMobileStore("Android")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default WSAInstallationPage;
